import React from 'react';
import MaskedInput from 'react-text-mask';

export default function MaskNumber(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      mask={[/\d/, /\d/, /\d/, /\d/, /\d/]} // Máscara para 5 dígitos numéricos
      placeholderChar={'\u2000'}
    />
  );
}
